import { AfterViewInit, Directive, ElementRef, HostListener, inject } from '@angular/core';

@Directive({
  selector: 'textarea[appAutoResizeTextarea]',
  standalone: true,
})
export class AutoResizeTextareaDirective implements AfterViewInit {
  private readonly elementRef = inject(ElementRef<HTMLTextAreaElement>);

  ngAfterViewInit(): void {
    // Use setTimeout to ensure the value is rendered before resizing
    setTimeout(() => this.resize());
  }

  @HostListener('input')
  onInput(): void {
    this.resize();
  }

  private resize(): void {
    const textarea = this.elementRef.nativeElement;
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }
}
